<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

setTimeout(() => {

  const pickupText = document.querySelector('.pickup-availability-info .text');

  if (
    pickupText &&
    pickupText.textContent.includes('Pickup currently unavailable at')
  ) {

    const svgElement = document.createElement('span');

    svgElement.innerHTML = `
      <svg id="iconclose" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="16" height="16" style="margin-right:6px;vertical-align:middle;fill:red;">
        <path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"></path>
      </svg>
    `;

    // Add before text
    pickupText.prepend(svgElement);

    console.log('SVG Added Before Text');
  }

}, 3000);

/* ============================================================================
   International Shipping Popup — DISABLED by Viktor (2026-06-04)
   Was: geo-targeted popup for non-AU visitors via ipapi.co
   To re-enable: restore the popup code block below this comment.
   ============================================================================ */
